import draftToHtml from 'draftjs-to-html';

import { JSONObject } from 'global/graphql/scalars.type';
import { ContentPageText } from './content-page.style';

type Props = {
  content: JSONObject | null;
};

export const ContentPageRichtextContent = ({ content, ...rest }: Props) => (
  <ContentPageText
    as="div"
    dangerouslySetInnerHTML={{ __html: draftToHtml(content) }}
    {...rest}
  />
);
